module.exports = __webpack_public_path__ + "img/21.0ee765e8.png";